import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TipoPeriodoService {
  constructor(private apiService: ApiService) {}
  private readonly path = 'bolsa';

  // List all TipoPeriodo
  list(params?: any): Observable<any[]> {
    return this.apiService
      .get<{ data: any[] }>(`${this.path}/getAllTipoPeriodo`, params)
      .pipe(map((response) => response.data));
  }

  // Get TipoPeriodo by ID
  show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getTipoPeriodoById/${id}`)
      .pipe(map((response) => response.object));
  }

  // Create new TipoPeriodo
  store(tipoPeriodo: any): Observable<any> {
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddTipoPeriodo`, tipoPeriodo)
      .pipe(map((response) => response.object));
  }

  // Update existing TipoPeriodo
  update(tipoPeriodo: any): Observable<any> {
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateTipoPeriodo`, tipoPeriodo)
      .pipe(map((response) => response.object));
  }

  // Delete TipoPeriodo by ID
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteTipoPeriodoById/${id}`);
  }
}